import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

export default {
  referencesHome: () => {
    new Swiper('.references-home', {
      spaceBetween: 40,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      slidesPerGroup: 1,
      pagination: {
        el: '.swiper-pagination-references',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 640px
        640: {
          spaceBetween: 90,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 2,
          spaceBetween: 0,
          loop: false,
          centeredSlides: false,
        },
      }
    });
  },

  referencesMultiple: () => {
    new Swiper('.references-multiple', {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-multiple-references-next',
        prevEl: '.swiper-button-multiple-references-prev',
      },
      breakpoints: {
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
        },
      },
    });
  },
}
